import request from '@/shared/api/request';

export const deleteBucketsKeys = (): Promise<unknown> =>
  request({
    url: '/buckets/keys/',
    method: 'DELETE',
  });
